

















import { AutoLoadContext } from '@/components/organisms/auto-load/model'
import {
  AutoLoadByFkuIds,
  AutoLoadStrategy,
  AutoLoadWithQuery,
} from '@ajax/vue/components/templates/item-list/paging/strategy/auto-load-strategy'
import { Either } from 'fp-ts/lib/Either'
import _ from 'lodash'
import Vue from 'vue'
import { Component, Prop } from 'vue-property-decorator'

import AppId from '@/util/appid'
import { BrandRouteResolver } from '@/util/brandRouteResolver'

import ItemListAutoLoadable from '@/components/organisms/item-list/AutoLoadable.vue'
import { AutoLoadError } from '@/components/organisms/item-list/model/auto-loadable'
import { ListWithPagination } from '@/models/api/response/list'
import { ItemKind } from '@/models/item/kind'
import ItemService from '@/services/api/productclass'
import SelectThumbnailImageBuilder from '@/services/product-image/select-thumbnail-image-builder'

import { log } from '@/log'
import { withoutPagingQuery } from './item-list/paging/query'

@Component({
  components: {
    ItemListAutoLoadable,
  },
})
/**
 * MPAの商品一覧画面 or フリーコンテンツの商品リストから使用される商品一覧表示コンポーネント
 */
export default class Itemlist extends Vue {

  @Prop({ default: () => ({}) })
  query: { [key: string]: any }

  @Prop({ required: true })
  displayType: string

  @Prop({ default: 24 })
  defaultCount: number

  @Prop({ default: false })
  instaview: boolean

  @Prop({ default: 3 })
  column: number

  @Prop({ default: false })
  instapage: boolean

  @Prop({ default: false })
  dynamicMode: boolean

  @Prop({ default: false })
  counterMode: boolean

  @Prop({ default: 'default' })
  itemKind: ItemKind

  @Prop({ default: null })
  displayLevelOfImageToDisplay: number | null

  @Prop({ default: null })
  imageAppKindOfImageToDisplay: string | null

  @Prop({ default: null })
  ids: null | {
    /** 指定ID全体 */
    all: string[]
    /** サーバーで取得・描画済みのID */
    loadedOnServer: string[],
    /** clientでオートロードする予定のID */
    loadOnClient: string[]
  }

  get basePage(): number {
    const ajaxBasePage = 2

    return ajaxBasePage
  }

  get appId(): string {
    return AppId.getByBrandName(
      BrandRouteResolver.resolveBrandFromPathElement(this.$route.params.brand_english_name)
    )
  }

  get itemService(): ItemService {
    return new ItemService(this.appId)
  }

  get selectThumbnailImageBuilder(): SelectThumbnailImageBuilder {
    return this.itemKind === 'contact-lens' ?
      SelectThumbnailImageBuilder.createForContactLens(
        this.instapage,
        this.displayLevelOfImageToDisplay,
        this.imageAppKindOfImageToDisplay
      ) :
      SelectThumbnailImageBuilder.createForApparel(this.instapage)
  }

  fetchItemList(baseQuery: object, context: AutoLoadContext): Promise<Either<Error, ListWithPagination<any>>> {
    return this.pagingStrategy.fetchPage(
      {
        ...baseQuery,
        ...withoutPagingQuery(this.query),
      },
      context
    )
  }

  onError(error: AutoLoadError) {
    log.error(error)
  }

  private get pagingStrategy(): AutoLoadStrategy<any> {
    return this.ids === null
      ? new AutoLoadWithQuery({
        productclassService: this.itemService,
      })
      : new AutoLoadByFkuIds({
        ids: this.ids,
        productclassService: this.itemService,
        countPerPage: this.defaultCount,
      })
  }
}
